/* eslint-disable indent */
import { Col, Row } from 'react-bootstrap';
import { MdClear } from 'react-icons/md';
import { useLocation, useHistory } from 'react-router-dom';
import { ButtonCleanFilters } from './styles';

export const Filters = () => {
  const history = useHistory();
  const location = useLocation();
  const querySearch = location.search?.substring(1)
    ? Object.entries(
        JSON.parse(
          `{"${decodeURI(location.search?.substring(1))
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')}"}`,
        ),
      )
    : [];
  const filterPageIndex = querySearch.findIndex(item => item[0] === 'page');
  if (filterPageIndex > -1) {
    querySearch.splice(filterPageIndex, 1);
  }

  const handleRemoveFilter = (type: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.delete(type);

    history.push({
      pathname: history.location.pathname,
      search: urlSearchParams.toString(),
    });
  };

  if (querySearch.length === 0) {
    return null;
  }

  return (
    <Row className="mt-3">
      <Col xs={9} className="d-flex">
        {querySearch.map(item => (
          <ButtonCleanFilters key={item[0]}>
            <span>{String(item[1])}</span>
            <button
              type="button"
              title="Remover"
              onClick={() => handleRemoveFilter(item[0])}
            >
              <MdClear />
            </button>
          </ButtonCleanFilters>
        ))}
      </Col>
      <Col xs={3} className="d-flex justify-content-end">
        <button
          type="button"
          className="bg-transparent border-0 btn-link"
          onClick={() => history.push(history.location.pathname)}
        >
          Limpar filtros
        </button>
      </Col>
    </Row>
  );
};
